import { render, staticRenderFns } from "./DieticianUploadsCard.vue?vue&type=template&id=00cee95c&scoped=true&"
import script from "./DieticianUploadsCard.vue?vue&type=script&lang=js&"
export * from "./DieticianUploadsCard.vue?vue&type=script&lang=js&"
import style0 from "./DieticianUploadsCard.vue?vue&type=style&index=0&id=00cee95c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cee95c",
  null
  
)

export default component.exports